import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 14H8a2 2 0 1 1 0-4h8a2 2 0 1 1 0 4" })
);
var SvgIndeterminateFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var IndeterminateFilled_default = SvgIndeterminateFilled;

export { IndeterminateFilled_default as default };
